import { graphql } from "gatsby";
import React, { FC, useMemo } from "react";

import { Container } from "../../container";
import { RichText } from "../../rich-text";
import { Accordion } from "./accordion";

export interface AccordionSectionProps extends Queries.AccordionSectionDataFragment {}

export const AccordionSection: FC<AccordionSectionProps> = ({ title, description, items }) => {
  const nonEmptyItems = useMemo(
    () => Array.from(items ?? []).filter(Boolean) as Queries.AccordionItemDataFragment[],
    [items]
  );

  return (
    <Container className="py-8 lg:py-20 bg-neutral" pagePaddingX>
      <h3 className="font-medium text-4xl mb-8 text-primary">{title}</h3>

      <div className="flex flex-col lg:flex-row gap-10 lg:gap-20 xl:gap-40 w-full">
        {description?.raw && (
          <div className="text-lg flex-1">
            <RichText raw={description.raw} />
          </div>
        )}
        <div className="flex-1">
          <Accordion items={nonEmptyItems} />
        </div>
      </div>
    </Container>
  );
};

export const query = graphql`
  fragment AccordionSectionData on ContentfulAccordionSection {
    title
    description {
      raw
    }
    items {
      ...AccordionItemData
    }
  }
`;
